<template>
  <main>
    <b-form @submit.stop.prevent="handleSubmitKreditcheck">
      <fieldset>
        <b-form-row>
          <b-col sm="12" md="4" lg="4">
            <b-form-group label="Fødselsdato" label-for="cprInput" class="px-4 font-weight-bold">
              <b-form-input id="cprInput" v-model="creditCheck.cprNumber" class="rounded"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col sm="12" md="4" lg="4">
            <b-form-group label="Fornavn" label-for="firstnameInput" class="px-4 font-weight-bold text-dark">
              <b-form-input id="firstnameInput" v-model="creditCheck.firstName" class="rounded"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col sm="12" md="4" lg="4">
            <b-form-group label="Efternavn" label-for="lastnameInput" class="px-4 font-weight-bold text-dark">
              <b-form-input id="lastnameInput" v-model="creditCheck.lastName" class="rounded"></b-form-input>
            </b-form-group>
          </b-col>
        </b-form-row>
        <!-- <b-form-row>
          <b-col lg="6" md="6" sm="12">
            <b-form-group label="Fornavn" label-for="firstnameInput" class="px-4 font-weight-bold text-dark">
              <b-form-input id="firstnameInput" v-model="creditCheck.firstName" class="rounded"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col lg="6" md="6" sm="12">
            <b-form-group label="Efternavn" label-for="lastnameInput" class="px-4 font-weight-bold text-dark">
              <b-form-input id="lastnameInput" v-model="creditCheck.lastName" class="rounded"></b-form-input>
            </b-form-group>
          </b-col>
        </b-form-row> -->
        <!-- <b-form-row>
          <b-col lg="6" md="6" sm="12">
            <b-form-group label="Addresse" label-for="streetNameInput" class="px-4">
              <b-form-input id="streetNameInput" v-model="creditCheck.streetName" class="rounded"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col lg="6" md="6" sm="12">
            <b-form-group label="Tel" label-for="TelInput" class="px-4">
              <b-form-input id="phone" v-model="creditCheck.phone" class="rounded"></b-form-input>
            </b-form-group>
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col lg="6" md="6" sm="12">
            <b-form-group label="Postnummer" label-for="zipInput" class="px-4">
              <b-form-input id="zipInput" v-model="creditCheck.zip" class="rounded"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col lg="6" md="6" sm="12">
            <b-form-group label="By" label-for="cityInput" class="px-4">
              <b-form-input id="cityInput" v-model="creditCheck.city" class="rounded"></b-form-input>
            </b-form-group>
          </b-col>
        </b-form-row> -->
        <b-form-row>
          <b-col>
            <b-form-group label-for="consentInput" class="px-4">
              <b-form-checkbox id="consentInput" v-model="creditCheck.consent" value="accepted" required unchecked-value="not_accepted">
                <span class="text-secondary open-sans">Neostructuralist rationalism holds that language is capable of truth, given that the premise of the conceptualist paradigm of reality is invalid. Thus, many discourses concerning the common ground between sexual identity and society may be discovered.</span>
              </b-form-checkbox>
            </b-form-group>
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col>
            <div class="d-flex justify-content-center py-4">
              <b-btn variant="success" type="submit" :disabled="isLoadingSubmit"  size="lg" class="rounded mx-auto mb-4">
                <span class="el-icon-d-arrow-right"></span>
                Send forspørgslen
              </b-btn>
            </div>
          </b-col>
        </b-form-row>
      </fieldset>
    </b-form>
  </main>
</template>
<script>
export default {
  name: 'creditcheckform',
  props: ['creditCheck', 'isLoadingSubmit'],
  components: {
  },
  data () {
    return {
    }
  },
  methods: {
    handleSubmitKreditcheck () {
      this.$emit('creditSubmit')
    }
  },
  computed: {
  }
}
</script>
<style scoped>
.slider-horizontal {
  min-width: 100%;
}
.sliderDiv > .d-inline-block {
  display: block!important;
}
.initialism {
  text-transform: none;
}
</style>


// WEBPACK FOOTER //
// CreditCheckForm.vue?52bfd20c